import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IconChevronDown, IconMenu2 } from '@tabler/icons-react';
import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@nextui-org/react';
import { Logo } from '../assets/images';
import { classNames, findRouteName } from '../utils';
import { IconAdminMenu2, IconAdminMenu3, IconAdminMenu4, IconMenuHome } from '../assets/icons';
import { useState } from 'react';

const navigation = [
  { name: 'Inicio', path: '/', icon: IconMenuHome },
  { name: 'Planes de Suscripción', path: '/pricing', icon: IconAdminMenu2 },
  {
    name: 'Reportes',
    icon: IconAdminMenu3,
    path: 'reports',
    submenu: [
      { name: 'Usuarios registrados', path: '/reports/users', icon: '' },
      { name: 'Reporte de pagos', path: '/reports/payments', icon: '' },
    ]
  },
  {
    name: 'Configuración del sistema',
    icon: IconAdminMenu4,
    path: 'settings',
    submenu: [
      { name: 'Cuentas de pago', path: '/settings/payment-methods/info', icon: '' },
    ]
  },
];


const Layout = () => {
  const nav = useNavigate();
  const user = useSelector(state => state.user);
  const location = useLocation();
  const routeName = findRouteName(location.pathname, navigation);;
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    const items = document.getElementsByClassName('desk-sidebar');
    for (let key = 0; key < items.length; key++) {
      items.item(key).classList.toggle('open');
    }
    setIsSidebarOpen(!isSidebarOpen);
  }

  return (
    <div id="layout" className="layout-admin">
      <div className="desk-sidebar desk-sidebar__header">
        <div className="sidebar-logo">
          <div className="sidebar-logo__wrapper">
            <img className="sidebar-logo__cropped" src={Logo} alt={process.env.REACT_APP_NAME} />
            <img className="sidebar-logo__normal" src={Logo} alt={process.env.REACT_APP_NAME} />
          </div>
        </div>
        <div className="desk-headerbar">
          <button type="button" className="-mr-2.5 p-2.5 text-foreground" onClick={toggleSidebar}>
            <span className="sr-only">Open sidebar</span>
            <IconMenu2 />
          </button>

          <div className="h-6 w-px bg-gray-200" aria-hidden="true" />

          <div className="flex gap-4 items-center">
            <div id="desk-headerbar-left-slot" className="hidden" />
            <span className="font-medium text-lg">{routeName}</span>
          </div>

          <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
            <div className="relative flex flex-1" />
            <div className="flex items-center gap-x-4 lg:gap-x-6">
              <div className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200" aria-hidden="true" />

              <div className="relative">
                <Dropdown placement="bottom-start">
                  <DropdownTrigger disabled={false}>
                    <Button variant="bordered">
                      <span className="font-semibold leading-6 text-gray-900" aria-hidden="true">
                        {user?.name}
                      </span>
                      <IconChevronDown className="ml-2 text-gray-400" size={18} />
                    </Button>
                  </DropdownTrigger>

                  <DropdownMenu aria-label="User Actions" variant="flat">
                    <DropdownItem key="logout" color="danger" textValue="Cerrar sesión" onPress={() => nav('/logout')}>
                      Cerrar sesión
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SideBar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <main>
        {!!user && <Outlet />}
      </main>
    </div>
  )
}

const SideBar = ({ isSidebarOpen, toggleSidebar }) => {
  const location = useLocation();
  const [openSubmenus, setOpenSubmenus] = useState({});

  const toggleSubmenu = (path) => {
    if (!isSidebarOpen) toggleSidebar();
    setOpenSubmenus((prev) => ({
      ...prev,
      [path]: !prev[path],
    }));
  };


  return (
    <div className="desk-sidebar">
      <aside>
        <div>
          <nav className="flex flex-1 flex-col">
            <ul className="flex flex-1 flex-col -mx-2 space-y-1">
              {navigation.map((item, index) => {
                const isActive = location.pathname === item.path;
                const isOpen = openSubmenus[item.path] || false;

                return (
                  <li key={index} className="menu-item" title={item.name}>
                    <div
                      className={classNames(
                        isActive ? 'text-primary active' : 'text-foreground-600 hover:text-primary',
                        'group flex justify-between items-center gap-x-3 py-1 rounded-md leading-6 font-semibold cursor-pointer'
                      )}
                      onClick={() => item.submenu && toggleSubmenu(item.path)}
                    >
                      <div className="flex items-center gap-x-3">
                        <Link
                          to={item.path}
                          className={classNames(
                            isActive
                              ? 'text-primary active'
                              : 'text-foreground-600 hover:text-primary',
                            'group flex gap-x-3 rounded-md leading-6 font-semibold'
                          )}
                        >
                          <img src={item.icon} className={classNames('aspect-square shrink-0', isActive ? 'text-primary' : 'text-foreground-600 group-hover:text-foreground')} alt="" />
                          <span>{item.name}</span>
                        </Link>

                      </div>
                      {item.submenu && isSidebarOpen && (
                        <IconChevronDown
                          className={classNames(
                            'transition-transform',
                            isOpen ? 'rotate-180' : 'rotate-0'
                          )}
                          size={18}
                        />
                      )}
                    </div>


                    {item.submenu && isOpen && (
                      <ul className="ml-6 space-y-1">
                        {item.submenu.map((subItem, subIndex) => (
                          <li key={subIndex} className="menu-subitem">
                            <Link
                              to={subItem.path}
                              className={classNames(
                                location.pathname === subItem.path
                                  ? 'text-primary active'
                                  : 'text-foreground-600 hover:text-primary',
                                'group flex gap-x-3 rounded-md px-2 py-1 leading-6 font-semibold'
                              )}
                              title={subItem.name}
                            >
                              <span>{subItem.name}</span>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}

                  </li>
                )
              })}
            </ul>
          </nav>
        </div>
      </aside>
    </div>
  )
}


export default Layout;